<template>
  <tr class="table__row dashboard__table-row">
    <td class="dashboard__table-title">
      <div class="layout--ellipses">
        <strong>{{ timer.widget.name }}</strong>
      </div>
    </td>
    <td v-if="timer.ended" class="table__cell dashboard__table-status">
      <span class="button button--narrow dashboard__status hide-tablet"
        ><strong class="weight--bold">ENDED</strong></span
      >
    </td>
    <td
      class="table__cell dashboard__table-count-time layout--flex-start layout--flex-align-start"
    >
      <IconCounting
        v-if="!timer.ended"
        class="icon icon--medium"
        style="width: 17px; height: 19px; margin: 3px 11px 0 2.5px;"
      />
      <IconEnded
        v-if="timer.ended"
        class="icon icon--medium"
        style="width: 17px; height: 19px; margin: 3px 11px 0 2.5px;"
      />
      <span v-html="htmlTime"></span>
    </td>
    <!-- <td
      class="table__cell dashboard__table-impressions layout--flex-start layout--flex-align-start"
    >
      <IconEye
        class="icon icon--medium"
        style="width: 22px; height: 14px; margin: 6px 8px 0 0"
      />
      <span
        >{{ timer.impressionCount.toLocaleString("en-US") }}<br />
        Impressions <i>(30 days)</i></span
      >
    </td> -->
    <td align="right" class="dashboard__table-controls">
      <Controls :timer="timer" listView />
    </td>
  </tr>
</template>

<script>
import { mapActions } from "vuex";

import Controls from "../../../../components/TimerControls";

import IconCounting from "../../../../assets/icons/iconTimerCounting.svg";
import IconEnded from "../../../../assets/icons/iconTimerEnded.svg";
import IconEye from "../../../../assets/icons/iconImpressionsEye.svg";

export default {
  name: "table-list-item",
  props: {
    timer: Object,
  },
  components: {
    IconCounting,
    IconEnded,
    IconEye,
    Controls,
  },
  computed: {
    htmlTime() {
      return this.timer.endDateTimeZoneFormatted.replace(/(:?\:\d\d)\s(:?[AP]M)/, '$1&nbsp;$2')
    }
  },
  methods: {
    ...mapActions("account", ["updateTimer"]),
  },
};
</script>

<style></style>
